module.exports = __webpack_public_path__ + "static/img/icon_gj_hover.d7067db0.svg";